import { SearchResponses, SearchResponse } from 'algoliasearch';

import { searchClient } from '@/lib/search/algolia';
import { SearchHit, SearchResults } from '@/lib/models/Search';
import { INDEX_NAME } from '@/lib/constants/Search';

export async function fetchResults(query: string, locale: string, objectType: string | string[], page: number = 0): Promise<SearchResults> {
  const objectTypes = Array.isArray(objectType) ? objectType : [objectType];
  const algoliaPage = Math.max(page - 1, 0);

  const response: SearchResponses = await searchClient.search([
    {
      indexName: INDEX_NAME,
      query,
      hitsPerPage: 20,
      page: algoliaPage,
      facetFilters: [[`language:${locale}`], objectTypes.map((type: string) => `objectType:${type}`)],
    },
  ]);

  // @ts-ignore
  const searchResponse = response.results[0] as SearchResponse<SearchHit>;

  return {
    hits: searchResponse.hits ?? [],
    count: searchResponse.nbHits ?? 0,
    totalPages: searchResponse.nbPages ?? 0,
  };
}
